// src/components/Layout.jsx
import React, { Suspense } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import Sidebar from './Sidebar';
import { ParentChildProvider } from '../context/ParentChildContext';
import { MobileNavProvider, useMobileNav } from '../context/MobileNavContext';
import { UnsavedChangesProvider } from '../context/UnsavedChangesContext';
import { getActiveRole } from '../utils/auth';
import PlayingChallengeToast from './PlayingChallengeToast';
import ChessCoachWidget from './playing/ChessCoachWidget';
import { ChessCoachProvider } from '../context/ChessCoachContext';

const PageLoader = () => (
    <div className="flex justify-center items-center h-[60vh]">
        <div className="w-9 h-9 border-4 border-gray-200 border-t-primary-500 rounded-full animate-spin" />
    </div>
);

function LayoutBody() {
    const location = useLocation();
    const { isOpen, close } = useMobileNav();
    const pathname = (location?.pathname || '').replace(/\/+$/, '') || '/';
    // Meeting stays inside the normal app frame (header + sidebar). Only select-role hides nav.
    const hideSidebar = pathname === '/select-role';

    const content = (
        <Suspense fallback={<PageLoader />}>
            <Outlet />
        </Suspense>
    );

    return (
        <div className="flex flex-col min-h-screen min-h-[100dvh] bg-transparent">
            <Header showMenuButton={!hideSidebar} />

            <div className="flex flex-1 w-full min-w-0 relative min-h-0">
                {!hideSidebar && (
                    <>
                        {isOpen && (
                            <div
                                className="fixed inset-0 z-30 bg-black/50 backdrop-blur-sm lg:hidden"
                                onClick={close}
                                aria-hidden="true"
                            />
                        )}
                        <Sidebar />
                    </>
                )}

                <main className="flex-1 min-w-0 w-full flex flex-col min-h-0 overflow-y-auto">
                    <div className="flex min-h-0 w-full min-w-0 flex-1 flex-col pb-[max(1rem,env(safe-area-inset-bottom))] py-3 sm:py-4 px-3 sm:px-4 md:px-6">
                        {getActiveRole() === 'PARENT' ? (
                            <ParentChildProvider>
                                {content}
                            </ParentChildProvider>
                        ) : (
                            content
                        )}
                    </div>
                </main>
            </div>

            <Footer />
            <PlayingChallengeToast />
            <ChessCoachWidget />
        </div>
    );
}

const Layout = () => (
    <MobileNavProvider>
        <UnsavedChangesProvider>
            <ChessCoachProvider>
                <LayoutBody />
            </ChessCoachProvider>
        </UnsavedChangesProvider>
    </MobileNavProvider>
);

export default Layout;
